/**
 * 점검 관리 페이지
 * 관리자(PRM_CODE = 'A')만 접근 가능
 */
import React, { useState } from 'react';
import { useMaintenanceData } from '../hooks/useMaintenanceData';
import { Maintenance, CreateMaintenanceRequestDto, UpdateMaintenanceRequestDto } from '../types/maintenance.types';
import { MaintenanceTable } from './MaintenanceTable';
import { MaintenanceModal } from './MaintenanceModal';
import '../styles/MaintenanceManagementPage.css';

export const MaintenanceManagementPage: React.FC = () => {
    const {
        maintenances,
        loading,
        msgCodes,
        createMaintenance,
        updateMaintenance,
        deleteMaintenance
    } = useMaintenanceData();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedMaintenance, setSelectedMaintenance] = useState<Maintenance | null>(null);

    // 등록 버튼 클릭
    const handleCreate = () => {
        setSelectedMaintenance(null);
        setIsModalOpen(true);
    };

    // 수정 버튼 클릭
    const handleEdit = (maintenance: Maintenance) => {
        setSelectedMaintenance(maintenance);
        setIsModalOpen(true);
    };

    // 삭제 버튼 클릭
    const handleDelete = async (seqNo: number) => {
        if (window.confirm('정말 삭제하시겠습니까?')) {
            await deleteMaintenance(seqNo);
        }
    };

    // 모달 저장
    const handleSave = async (data: CreateMaintenanceRequestDto | UpdateMaintenanceRequestDto) => {
        let success = false;
        if (selectedMaintenance) {
            success = await updateMaintenance(data as UpdateMaintenanceRequestDto);
        } else {
            success = await createMaintenance(data as CreateMaintenanceRequestDto);
        }
        if (success) {
            setIsModalOpen(false);
            setSelectedMaintenance(null);
        }
    };

    // 모달 닫기
    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedMaintenance(null);
    };

    return (
        <div className="maintenance-management-page">
            <div className="page-header">
                <h2>점검 관리</h2>
                <button className="btn btn-primary" onClick={handleCreate}>
                    점검 등록
                </button>
            </div>

            <div className="page-content">
                <MaintenanceTable
                    maintenances={maintenances}
                    loading={loading}
                    msgCodes={msgCodes}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                />
            </div>

            {isModalOpen && (
                <MaintenanceModal
                    maintenance={selectedMaintenance}
                    msgCodes={msgCodes}
                    onSave={handleSave}
                    onClose={handleCloseModal}
                    loading={loading}
                />
            )}
        </div>
    );
};

export default MaintenanceManagementPage;
